module.exports = __webpack_public_path__ + "static/media/mobile_pt-BR.c6326dc1.mp4";